import angular from 'angular'
import outSystemCtrl from './outSystemCtrl'
import outSystemListCtrl from './outSystemListCtrl'
import outSystemInfoCtrl from './outSystemInfoCtrl'
import {
    infoRouter, addRouter, SysRouter, editRouter,
} from './Routers'

export default angular
    .module('system.syssetting.outSystem', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider.state(infoRouter.state, infoRouter.config)
            .state(addRouter.state, addRouter.config)
            .state(editRouter.state, editRouter.config)
            .state(SysRouter.state, SysRouter.config)
    }])
    .controller('outSystemCtrl', outSystemCtrl)
    .controller('outSystemListCtrl', outSystemListCtrl)
    .controller('outSystemInfoCtrl', outSystemInfoCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/outsystem/index.js